/**
 * source: https://dmitripavlutin.com/timeout-fetch-request/
 * @param resource
 * @param options
 */
export default async (resource: string, options = {}) => {
    const { timeout = 8000 } = options
    
    const controller = new AbortController()
    const id = setTimeout(() => controller.abort(), timeout)
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id)
    
    return response
}